// extracted by mini-css-extract-plugin
export default {"wrapper":"Accordion_wrapper__MSPhU","title":"Accordion_title__9POVm","toolbar":"Accordion_toolbar__6IQIZ","content":"Accordion_content__mG3AV"};